import { GetMonthlyInstallmentTypeOptions } from '~domain/helper/premiums/installment/carrier-installment-type';
import { GetTotalOptions } from '../common/get-total';

export type GetMonthlyInstallmentOptions = GetMonthlyInstallmentTypeOptions & Partial<GetTotalOptions>;

export interface GetInstallment {
  getMonthlyInstallment: (options: GetMonthlyInstallmentOptions) => MonthlyInstallment;
}

export type AssetMonthlyInstallments = Record<string, MonthlyInstallment>;

export type MonthlyInstallment =
  | {
      type: MonthlyInstallmentType.EvenlyDistributed;
      installment: EvenlyDistributedMonthlyInstallment;
    }
  | {
      type: MonthlyInstallmentType.OneMonthInAdvance | MonthlyInstallmentType.TwoMonthInAdvance;
      installment: MonthsInAdvanceMonthlyInstallment;
    };

export interface EvenlyDistributedMonthlyInstallment {
  monthlyPayment: number;
}

export interface MonthsInAdvanceMonthlyInstallment {
  firstMonthPayment: number;
  subsequentMonthlyPayment: number;
}

export enum MonthlyInstallmentType {
  EvenlyDistributed = 'evenlyDistributed',
  OneMonthInAdvance = 'oneMonthInAdvance',
  TwoMonthInAdvance = 'twoMonthInAdvance',
}
